/**
 * Custom hook to manage the state and visibility of the UI panels
 * (Desktop and Styling) and the mobile preview settings (device and orientation).
 * It also contains the logic for automatically closing panels for better viewing.
 */

import { useState, useEffect } from 'react';

export const usePanelManager = () => {
    const [isDesktopPanelOpen, setDesktopPanelOpen] = useState(true);
    const [isStylingPanelOpen, setStylingPanelOpen] = useState(false);
    const [device, setDevice] = useState('phone');
    const [orientation, setOrientation] = useState('portrait');

    // Effect to automatically close side panels when switching to a larger view
    useEffect(() => {
        if (device === 'tablet' || orientation === 'landscape') {
            setDesktopPanelOpen(false);
            setStylingPanelOpen(false);
        }
    }, [device, orientation]);

    //Toggles the visibility of the left (Desktop) panel. Ensures the right panel is closed and resets the device view.
    const toggleDesktopPanel = () => {
        const opening = !isDesktopPanelOpen;
        setDesktopPanelOpen(opening);
        if (opening) {
            setStylingPanelOpen(false);
            setDevice('phone');
            setOrientation('portrait');
        }
    };

    //Toggles the visibility of the right (Styling) panel. Ensures the left panel is closed.
    const toggleStylingPanel = () => {
        const opening = !isStylingPanelOpen;
        setStylingPanelOpen(opening);
        if (opening) {
            setDesktopPanelOpen(false);
        }
    };

    const onDeviceChange = (newDevice) => setDevice(newDevice);
    const onOrientationChange = () => setOrientation(prev => (prev === 'portrait' ? 'landscape' : 'portrait'));

    return {
        isDesktopPanelOpen,
        isStylingPanelOpen,
        device,
        orientation,
        toggleDesktopPanel,
        toggleStylingPanel,
        onDeviceChange,
        onOrientationChange,
    };
};